import React from "react";
import configData from "../../../config.json";
import DateBox from "../DateBox";
import { useMediaQuery } from "react-responsive";

const getCurrentDates = () => {
  const today = new Date();
  const dayFormatter = new Intl.DateTimeFormat("en-US", { weekday: "short" });
  const generatedDates = [];

  for (let i = -3; i <= 3; i++) {
    const currentDate = new Date(today);
    currentDate.setDate(today.getDate() + i);

    generatedDates.push({
      date: currentDate.getDate(),
      day: dayFormatter.format(currentDate),
      patientDay: i + 4,
    });
  }

  return generatedDates;
};

function Embryonic({ weekwisedata, setExpand, setSelected }) {
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const activeDate = new Date().getDate();
  const dates = getCurrentDates();
  const wrapper = {
    marginLeft: isTabScreen ? "20px" : "50px",
    marginRight: isTabScreen ? "20px" : "50px",
    paddingLeft: isTabScreen ? "20px" : "50px",
    paddingBottom: "50px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: "30px",
    marginBottom: "50px",
    height: window.innerHeight,
    overflowY: "scroll",
  };
  return (
    <div>
      <div style={wrapper}>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "600",
            color: configData.THEME_COLORS.PRIMARY,
            marginTop: "30px",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelected(false);
            setExpand(true);
          }}
        >
          Back
        </div>

        <div
          style={{
            marginTop: "10px",
            fontSize: "24px",
            fontWeight: "600",
            color: configData.THEME_COLORS.SECONDARY,
          }}
        >
          Embryonic Development
        </div>
        <div
          className="w-100"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div
            style={{
              marginTop: isMobile ? "10px" : isTabScreen ? "15px" : "20px",
              alignSelf: "center",
              display: "flex",
              overflowX: "auto",
              justifyContent: "space-between",
              width: isMobile ? "95%" : "80%",
              alignItems: "center",
              height: isMobile ? "95px" : isTabScreen ? "100px" : "130px",
              gap: isMobile ? "8px" : "0px",
            }}
          >
            {dates.map((item, index) => (
              <DateBox
                key={`${item.day}-${item.date}-${index}`}
                day={item.day}
                date={item.date}
                patientDay={item.patientDay}
                size={"40px"}
                activeDay={activeDate}
              />
            ))}
            {/* <Carousel items={dates} active={0} /> */}
          </div>
        </div>
        <div
          style={{
            marginTop: "30px",
            alignSelf: "center",
            fontSize: "20px",
            fontWeight: "400",
            height: window.innerHeight / 2,
            width: "90%",
            overflow: "auto",
            marginTop: "54px",
          }}
        >
          {weekwisedata?.description}
        </div>
      </div>
    </div>
  );
}

export default Embryonic;
